/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1Icon16Light } from './People1Icon16Light';
import { People1Icon16Regular } from './People1Icon16Regular';
import { People1Icon16Solid } from './People1Icon16Solid';
import { People1Icon20Light } from './People1Icon20Light';
import { People1Icon20Regular } from './People1Icon20Regular';
import { People1Icon20Solid } from './People1Icon20Solid';
import { People1Icon24Regular } from './People1Icon24Regular';
import { People1Icon24Solid } from './People1Icon24Solid';
import { People1Icon32Regular } from './People1Icon32Regular';
import { People1Icon64Regular } from './People1Icon64Regular';
var sizes = {
    16: {
        light: People1Icon16Light,
        regular: People1Icon16Regular,
        solid: People1Icon16Solid,
    },
    20: {
        light: People1Icon20Light,
        regular: People1Icon20Regular,
        solid: People1Icon20Solid,
    },
    24: {
        regular: People1Icon24Regular,
        solid: People1Icon24Solid,
    },
    32: {
        regular: People1Icon32Regular,
    },
    64: {
        regular: People1Icon64Regular,
    },
};
export var People1Icon = forwardRef('People1Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
